export default {
	functional: true,
	render(h, ctx) {
		const { props, data, children } = ctx;
		const { attrs = {}, staticClass = {}, ...otherData } = data;
		let newClass = {};

		if (typeof staticClass === 'string') {
			newClass = {
				[staticClass]: true,
				'alert': true,
				'alert-danger': true,
			};
		} else {
			newClass = {
				...staticClass,
				'alert': true,
				'alert-danger': true,
			};
		}

		const errs = !Array.isArray(props.errors)
			? [props.errors]
			: h(
					'ul',
					props.errors.map((el) => h('li', [el]))
			  );

		return h(
			'div',
			{
				...otherData,
				class: newClass,
			},
			errs
		);
	},
};
